module.exports = __webpack_public_path__ + "img/lacrosse-stick-ball.10410db7.svg";